import { createAction, props } from '@ngrx/store';
import { Settings } from '../reducers/settings.reducer';

export const enum SettingsAction {
  SET_USER_SETTINGS = '[Settings] update user settings',
  RESET_SETTINGS = '[Settings] reset user settings'
}

export const updateUserSettings = createAction(SettingsAction.SET_USER_SETTINGS, props<Settings>());

export const resetSettings = createAction(SettingsAction.RESET_SETTINGS);
